import * as Yup from 'yup';
import { ERROR_MESSAGES, INPUT_PARAM_CONSTRAINTS } from './constants';

const validationSchema = Yup.object().shape({
	ambientTemperature: Yup.number()
		.typeError(ERROR_MESSAGES.ambientTemperatureNumber)
		.required(ERROR_MESSAGES.ambientTemperatureRequired)
		.test(
			'ambientTemperatureInRange',
			ERROR_MESSAGES.ambientTemperatureInRange,
			value =>
				parseFloat(value) >= INPUT_PARAM_CONSTRAINTS.AMB_TEMP_MIN &&
				parseFloat(value) <= INPUT_PARAM_CONSTRAINTS.AMB_TEMP_MAX
		)
});

export default validationSchema;
